import React from 'react';
import { motion } from 'framer-motion';
export function TeamSection() {
  return <section className="py-24 bg-slate-50" data-id="element-70">
      <div className="container mx-auto px-4 md:px-6" data-id="element-71">
        <div className="bg-white rounded-3xl p-8 md:p-16 shadow-sm border border-slate-100 text-center max-w-5xl mx-auto" data-id="element-72">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-73">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-74">
              We're a remote-first team of <br className="hidden md:block" data-id="element-75" />{' '}
              passionate builders
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-76">
              Remote Systems was founded on the belief that great software comes
              from great people, regardless of where they are located. Our
              distributed team spans 12 countries and 8 time zones.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}